module.exports = __webpack_public_path__ + "img/Phone_04.969cfd2c.jpg";